import Vue from 'vue'
import api from '../services/api'

Vue.directive('p', {
  async inserted(el,arg) {
    let arr = []
   // let res = await productSettingList()
    let res = JSON.parse(localStorage.getItem('productSetting'));
    res.map(item => {
      if(item.PropertyCode == arg.arg) {
        arr.push(item.PropertyCode)
      }
    })
    //console.log(arr, 999)
    let it = arr.includes(arg.arg)
    if(it) {
      el.style.display = ''
      return true
    } else {
      el.style.display = 'none'
      return false
    }
  }
})
